import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TTeam } from '../types/team.type';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';

/**
 *
 */
export const DeleteTeamValidationSchema = z.object({
  teamId: z.string({ required_error: 'Team ID is required' }),
});
export type TDeleteTeamValidation = z.infer<typeof DeleteTeamValidationSchema>;
export type TDeleteTeamPayload = TDeleteTeamValidation;
export type TDeleteTeamResponse = ApiResponse<TTeam>;

export const deleteTeam = (payload: TDeleteTeamPayload): Promise<TDeleteTeamResponse> => {
  const url = `/team/manage/${payload.teamId}`;

  return axiosInstance.delete(url);
};

/**
 *
 */
type UseDeleteTeamOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteTeam, AxiosErrorCustom>;
};

export const useDeleteTeam = ({ mutationConfig }: UseDeleteTeamOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TDeleteTeamResponse, AxiosErrorCustom, TDeleteTeamPayload>({
    mutationFn: deleteTeam,
    ...restConfig,
  });
};
